export default __webpack_public_path__ + "static/media/user-pics-6.23291267.png";